import axios from 'axios';
import dayjs from 'dayjs';
import { formatNumber } from './helper';

export async function GetMonitors(apikey, days) {

  const dates = [];
  const today = dayjs(new Date().setHours(0, 0, 0, 0));
  for (let d = 0; d < days; d++) {
    dates.push(today.subtract(d, 'day'));
  }

  const start = dates[dates.length - 1].unix();
  const end = dates[0].add(1, 'day').unix();

  const postdata = {
    api_key: apikey,
    format: 'json',
    logs: 1,
    log_types: '1-2',
    logs_start_date: start,
    logs_end_date: end,
  };

  const response = await axios.post('https://api.uptimerobot.com/v2/getMonitors', postdata, { timeout: 30000 });
  if (response.data.stat !== 'ok') throw response.data.error;
  return response.data.monitors.map((monitor) => {

    const daily = [];
    const map = [];
    dates.forEach((date, index) => {
      map[date.format('YYYYMMDD')] = index;
      daily[index] = {
        date: date,
        uptime: 100,
        down: { times: 0, duration: 0 },
      }
    });

    const total = (monitor.logs || []).reduce((total, log) => {
      if (log.type === 1) {
        const date = dayjs.unix(log.datetime).format('YYYYMMDD');
        total.duration += log.duration;
        total.times += 1;
        const day = daily[map[date]];
        if (day) {
          day.down.duration += log.duration;
          day.down.times += 1;
        }
      }
      return total;
    }, { times: 0, duration: 0 });

    daily.forEach((day) => {
      day.uptime = formatNumber(Math.max(0, 100 - day.down.duration / 864));
    });
    const average = formatNumber(Math.max(0, 100 - total.duration / (days * 864)));

    const result = {
      id: monitor.id,
      name: monitor.friendly_name,
      url: monitor.url,
      average: average,
      daily: daily,
      total: total,
      status: 'unknow',
    };

    if (monitor.status === 2) result.status = 'ok';
    if (monitor.status === 9) result.status = 'down';
    return result;
  });
}
